<ng-container *transloco="let t; read: 'ime.manufacturing.manufacturing-graph-modal'">
  <div class="modal-header" ngxModalDraggable>
    <h4 class="modal-title pull-left">{{t('Graph options')}}</h4>
    <button type="button" class="btn btn-success ms-auto" (click)="save(); close(this.options, 'apply')">
      <span aria-hidden="true">{{t('OK')}}</span>
    </button>
    <button type="button" class="btn-close ms-2" aria-label="Close" (click)="close()">
    </button>
  </div>
  <div class="modal-body">
    <div class="mb-3">
      <label class="form-label">{{t('Included types')}}</label>
      <help-tooltip-button [tip]="t('Types of object to show')"></help-tooltip-button>
      <ng-select class="select-sm form-control" appendTo="body" [items]="allNodeTypes" name="IncludeTypes" [multiple]="true" [(ngModel)]="options.IncludeTypes" bindValue="id" bindLabel="name"
                 groupBy="group" [selectableGroup]="true" [selectableGroupAsModel]="false" [closeOnSelect]="false">
        <ng-template ng-option-tmp let-item="item" let-item$="item$" let-index="index">
          <input id="include-{{index}}" type="checkbox" class="me-1" [ngModel]="item$.selected"/>{{item.name}}
        </ng-template>
      </ng-select>
    </div>
    <div class="mb-3">
      <label class="form-label">{{t('Filter By')}}</label>
      <ng-select class="select-sm form-control" appendTo="body" [items]="options.FilterBy" name="FilterBy" [multiple]="true" [ngModel]="options.FilterBy | where: 'State': true" bindLabel="Text" [closeOnSelect]="false" (remove)="$event.State = false" (add)="$event.State = true">
        <ng-template ng-option-tmp let-item="item" let-index="index">
          <input id="filter-{{index}}" type="checkbox" class="me-1" [checked]="item.State" (change)="item.State = !item.State" />{{item.Text}}
        </ng-template>
      </ng-select>
    </div>
    <div class="mb-3">
      <label class="form-label">{{t('Group by')}}</label>
      <help-tooltip-button [tip]="t('Show a single node instead of multiple of the same, by type')"></help-tooltip-button>
      <ng-select class="select-sm form-control" appendTo="body" [items]="allNodeTypes" name="GroupBy" [multiple]="true" [(ngModel)]="options.GroupBy" bindValue="id" bindLabel="name"
                 groupBy="group" [selectableGroup]="true" [selectableGroupAsModel]="false" [closeOnSelect]="false">
        <ng-template ng-option-tmp let-item="item" let-item$="item$" let-index="index">
          <input id="groupBy-{{index}}" type="checkbox" class="me-1" [ngModel]="item$.selected"/>{{item.name}}
        </ng-template>
      </ng-select>
    </div>
    <div class="mb-3">
      <label class="form-label">  {{t('Maximum Level')}}</label>
      <help-tooltip-button [tip]="t('How many levels up and down from current object are shown')"></help-tooltip-button>
      <div class="input-group">
        <input type="number" class="form-control" id="MaximumLevel" min="0" max="30" [(ngModel)]="options.MaximumLevel">
        <button type="button" class="btn btn-primary" [disabled]="options.MaximumLevel >= 30" (click)="options.MaximumLevel = options.MaximumLevel + 1">
          <svg viewBox="0 0 8 8" class="icon small" inlineSVG="#plus"></svg>
        </button>
        <button type="button" class="btn btn-primary" [disabled]="options.MaximumLevel <= 0" (click)="options.MaximumLevel = options.MaximumLevel - 1">
          <svg viewBox="0 0 8 8" class="icon small" inlineSVG="#minus"></svg>
        </button>
      </div>
    </div>
    <div class="custom-control custom-checkbox">
      <input type="checkbox" class="custom-control-input" id="HideByFalseValidCondition" [checked]="options.HideByFalseValidCondition" (change)="options.HideByFalseValidCondition = !options.HideByFalseValidCondition">
      <label class="custom-control-label" for="HideByFalseValidCondition">
        {{t('Hide where valid condition is False')}}
      </label>
      <help-tooltip-button [tip]="t('Show only valid routes')"></help-tooltip-button>
    </div>
    <div class="custom-control custom-checkbox">
      <input type="checkbox" class="custom-control-input" id="ShowSharedBranchesSeparately" [checked]="options.ShowSharedBranchesSeparately" (change)="options.ShowSharedBranchesSeparately = !options.ShowSharedBranchesSeparately">
      <label class="custom-control-label" for="ShowSharedBranchesSeparately">
        {{t('Show shared branches separately')}}
      </label>
      <help-tooltip-button [tip]="t('If a part of the route is used in multiple places (has multiple lines coming out from the right, but not because of Group by) then show it duplicated for each use')"></help-tooltip-button>
    </div>
    <div class="custom-control custom-checkbox">
      <input type="checkbox" class="custom-control-input" id="AreAlternativeInstructionsSkipped" [checked]="options.AreAlternativeInstructionsSkipped" (change)="options.AreAlternativeInstructionsSkipped = !options.AreAlternativeInstructionsSkipped">
      <label class="custom-control-label" for="AreAlternativeInstructionsSkipped">
        {{t('Skip alternatives')}}
      </label>
      <help-tooltip-button [tip]="t('Show only the first of the alternative instructions')"></help-tooltip-button>
    </div>
    <div class="custom-control custom-checkbox">
      <input type="checkbox" class="custom-control-input" id="IsBottomGraphShown" [checked]="options.IsBottomGraphShown" (change)="options.IsBottomGraphShown = !options.IsBottomGraphShown">
      <label class="custom-control-label" for="IsBottomGraphShown">
        {{t('Show connections to object')}}
      </label>
      <help-tooltip-button [tip]="t('Show this object\'s routing')"></help-tooltip-button>
    </div>
    <div class="custom-control custom-checkbox">
      <input type="checkbox" class="custom-control-input" id="IsTopGraphShown" [checked]="options.IsTopGraphShown" (change)="options.IsTopGraphShown = !options.IsTopGraphShown">
      <label class="custom-control-label" for="IsTopGraphShown">
        {{t('Show connections from object')}}
      </label>
      <help-tooltip-button [tip]="t('Show where this object is used')"></help-tooltip-button>
    </div>
  </div>
</ng-container>
